import type { SanityClient } from '@sanity/client';
import type { Context } from 'react';
import { createContext } from 'react';

const SanityClientContext: Context<SanityClient | undefined> = createContext<
  SanityClient | undefined
>(undefined);

export default SanityClientContext;
